<template>
	<div class="IndexBox">
	  <div class="ScrollBox">
		  <van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('user.office[4]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		  >
        <template #right>
          <span class="nav-right-btn" @click="goPositionIntro">
            {{$t('user.positions[9]')}}
          </span>
        </template>
      </van-nav-bar>
		<div class="content-wrapper" :style="{ '--bg-url': `url(${bgImageUrl})` }">
			<!-- <div class="position-title">position</div> -->

			<!-- 晋升级别列表（按 type 分组为主题块；已上传最后一级也会归入对应块） -->
			<div
				v-for="group in groupedReData"
				:key="group.type"
				class="reward-card"
				:style="getCardStyleByType(group.type)"
			>
				<!-- 组内每一个职位 -->
				<div
					v-for="entry in group.items"
					:key="entry.index"
					class="reward-item reward-card__inner"
				>
					<!-- 普通晋升级别卡片 -->
					<div class="reward-header">
						<img :src="getHeaderIconSrc(entry.item)" class="reward-icon" alt="type-icon"/>
						<span
							class="reward-text"
							:style="getTitleStyle(entry.item)"
						>
							<!-- {{$t('user.office[6]')}} ({{entry.item.name}}) -->
							{{entry.item.name}}
						</span>
						<span class="reward-award" :style="getTitleStyle(entry.item)">
							{{ formatAward(entry.item.award) }}TJS
						</span>
					</div>
					
					<div class="progress-container">
						<div class="progress-bar-wrapper">
							<div class="progress-info-row">
								<div class="progress-text">
									<span>{{entry.item.numberMembers}}</span>
									<span class="progress-separator">/</span>
									<span>{{entry.item.satisfy}}</span>
								</div>
							</div>
							<div class="progress-bar-row">
								<div class="progress-bar-bg" :style="getProgressTrackStyle(entry.item)">
									<div
										class="progress-bar-fill"
										:style="[
											{ width: entry.item.schedule + '%' },
											getProgressFillStyle(entry.item, entry.item.schedule)
										]"
									></div>
										<!-- 小车图标，根据职位 type 动态选择 -->
										<img
											:src="getBikeIconSrc(entry.item)"
											class="bike-icon"
											:style="{ left: Math.min(entry.item.schedule, 97) + '%' }"
											alt="bike"
										/>
								</div>
								<div
									class="progress-percent-out"
									:style="getTitleStyle(entry.item)"
								>
									{{ formatSchedule(entry.item.schedule) }}
								</div>
							</div>							
						</div>
						
						<div 
							v-if="canClaimReward(entry.item)" 
							class="action-btn active"
							:style="getActionBtnStyle(entry.item, 'active')"
							@click="openShow(entry.item)">
							{{$t('user.office[5]')}}
						</div>
						<div 
							v-else-if="entry.item.schedule==100 && entry.item.btn==true" 
							class="action-btn disabled">
							{{$t('user.office[12]')}}
						</div>
						<div v-else class="action-btn disabled">
							{{getButtonText(entry.item)}}
						</div>
					</div>
				</div>
			</div>

				<!-- 职位 5-7 档达标且需上传身份图片：单独显示在列表底部 -->
				<div
				v-if="showUploadCard && uploadTargetItem"
				class="reward-card"
				:style="getCardStyleByType(getThemeKey(uploadTargetItem))"
			>
				<div class="upload-section reward-card__inner">
					<div class="upload-header">
						<h4 class="upload-title">{{$t('positions.job[3]')}}</h4>
						<div class="upload-comments">
							<div class="comments-label">{{$t('positions.job[4]')}}：</div>
							<div>1：{{$t('positions.job[5]')}}</div>
							<div>2：{{$t('positions.job[6]')}}</div>
							<div>3：{{$t('positions.job[7]')}}</div>
							<div>4：{{$t('positions.job[23]')}}</div>
						</div>
					</div>
					<div class="upload-images" v-if="office==null || office.state==2">
						<van-uploader v-model="img_1" :after-read="afterRead" :upload-text="$t('positions.job[9]')" :max-count="1" class="upload-item"/>
						<van-uploader v-model="img_3" :after-read="afterRead" :upload-text="$t('positions.job[11]')" :max-count="1" class="upload-item"/>
						<van-uploader v-model="img_2" :after-read="afterRead" :upload-text="$t('positions.job[10]')" :max-count="1" class="upload-item"/>
					</div>
					<div class="upload-images" v-else>
						<img :src="office.img_1" class="uploaded-img"/>
						<img :src="office.img_2" class="uploaded-img"/>
						<img :src="office.img_3" class="uploaded-img"/>
					</div>
					<van-button 
						:disabled="office==null || office.state==2?false:true" 
						round 
						type="info" 
						block 
						class="submit-btn"
						@click="submitPostDebounce"> 
						{{$t('positions.job[18]')}} 
					</van-button>
				</div>
			</div>
			
			<!-- Awards部分 -->
			<!-- <div class="awards-section">
				<div class="awards-header">
					<img :src="staticBasePath + '/static/images/post/gift@2x.png'" class="awards-icon" alt="gift"/>
					<span class="awards-text">{{$t('apply.awardsTitle')}}</span>
				</div>
				<div class="awards-content" v-html="awardsContent"></div>
			</div> -->
		</div>
	  </div>

	  <!-- 领取奖励成功弹窗 -->
	  <van-popup v-model="showRewardSuccessPopup" :close-on-click-overlay="false" style="background: transparent; text-align: center">
	    <div
	      class="reward-success-popup"
	      :style="{ backgroundImage: `url(${rewardPopupBgUrl})` }"
	    >
	      <div class="reward-success-content">
	        <p class="reward-success-text">{{ rewardPopupMessage }}</p>
	        <van-button round class="reward-success-btn" @click="closeRewardPopup">
	          {{ $t('home.title[5]') }}
	        </van-button>
	      </div>
	    </div>
	    <a class="reward-close" href="javascript:;" @click="closeRewardPopup">
	      <van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem" />
	    </a>
	  </van-popup>
	</div> 
</template>

<script>
import lodash from "lodash";
export default {
	name:"Job Promotion",
	data(){
		return {
			rating: 0,
			showCon: false,
			infoData:'',
			reData:[],
			office:[],
			schedule:100,
			img_1:[],
			img_2:[],
			img_3:[],
			// 奖励内容，使用 v-html 渲染
			awardsContent: '',
			// 静态资源前缀（支持根路径 / 或二级目录 /sgm 等）
			staticBasePath: '',
			// 背景图完整 URL（包含前缀），用于 ::before
			bgImageUrl: '',
			// 领取奖励成功弹窗
			showRewardSuccessPopup: false,
			rewardPopupMessage: '',
			rewardPopupBgUrl: '',
			formData:{
				img_1:"",
				img_2:"",
				img_3:"",
				postid:''
			}
		}
	},
	computed: {
		// 职位 5-7 档中，达标的最高档（schedule==100）
		highestPost57Reached() {
			if (!Array.isArray(this.reData)) return null;
			const post57 = this.reData.filter((item) => {
				const post = Number(item.post);
				return post >= 5 && post <= 7;
			});
			const reached = post57.filter((item) => Number(item.schedule) >= 100);
			if (reached.length === 0) return null;
			return reached.reduce((a, b) => (Number(a.post) > Number(b.post) ? a : b));
		},

		// 是否需要显示“上传身份图片”卡片：职位 5-7 中至少一档达标，且尚未审核通过（仅需提交一次，审核通过后 6、7 档不再要求上传）
		showUploadCard() {
			const target = this.highestPost57Reached;
			if (!target) return false;
			// office 为空或未审核通过时显示上传；一旦审核通过，永不再次显示
			return !this.office || this.office.state != 1;
		},

		// 上传卡片对应的职位数据（用于主题样式和 formData.postid）
		uploadTargetItem() {
			return this.highestPost57Reached || null;
		},

		// 将原始职位列表按 type 分组，用于同一主题块中展示（默认显示全部职位）
		groupedReData() {
			const groups = {};
			if (!Array.isArray(this.reData)) return [];
			this.reData.forEach((item, index) => {
				const typeKey = this.getThemeKey(item);
				if (!groups[typeKey]) {
					groups[typeKey] = {
						type: typeKey,
						items: [],
					};
				}
				groups[typeKey].items.push({ item, index });
			});
			// 保持 type 升序排列，type=0（未知）排在最后
			return Object.values(groups).sort((a, b) => {
				if (a.type === 0) return 1;
				if (b.type === 0) return -1;
				return a.type - b.type;
			});
		},
	},
	watch: {
	},
	created() {
		this.$Model.GetUserInfo();
		this.$parent.navBarTitle = this.$t("user.office[4]")
		this.$Model.GetJobStatus(data=>{
		  if(data.code==1){
			this.reData = data.data;
			this.office = data.office;
		  }
		})

		// 根据当前访问路径自动计算静态资源前缀（支持根路径 / 与 /sgm 等二级目录）
		if (typeof window !== 'undefined') {
			const path = window.location.pathname || '/';
			const segments = path.split('/').filter(Boolean);
			// 仅取第一个路径段作为前缀，例如 /sgm/xxx -> /sgm
			const firstSegment = segments.length > 0 ? `/${segments[0]}` : '';
			this.staticBasePath = firstSegment;
			// 背景图完整 URL
			this.bgImageUrl = `${firstSegment}/static/images/post/bg@2x.png`;
		} else {
			// 非浏览器环境兜底
			this.staticBasePath = '';
			this.bgImageUrl = `/static/images/post/bg@2x.png`;
		}

		// 读取全局 InitData 中的奖励内容，若无则回退到后端获取
		this.loadInitData();
		
	},
	mounted() {
	},
	activated() {},
	destroyed() {},
		methods: {
		// 统一拼接静态资源路径（兼容根路径 / 与 /sgm 等二级目录）
		withStaticBase(relativePath) {
			const p = String(relativePath || '').replace(/^\/+/, '');
			return `${this.staticBasePath}/${p}`;
		},

		// 分块主题：直接按 type 分组（1/2/3），与接口字段保持一致
		// 备注：后端数据里 type 可能是 number 或 string，这里统一转成 number
		getThemeKey(item) {
			// 避免可选链在老构建工具中报错，使用显式判空
			const rawType = item && item.type;
			const type = Number(rawType);
			return Number.isFinite(type) ? type : 0;
		},

		getThemeConfig(itemOrType) {
			const key = typeof itemOrType === 'number'
				? itemOrType
				: this.getThemeKey(itemOrType);
			// 主题映射：直接使用 type 作为 key（1/2/5）
			const map = {
				1: {
					cardBg: '#E6FCF7',
					progressMain: '#164F63',
					progressEnd: '#E6FCF7',
					bike: 'static/images/post/bike@2x_1.png',
					frame: null,
					btnActive: '#164F63',
				},
				2: {
					cardBg: '#E5FEE6',
					progressMain: '#187C18',
					progressEnd: '#E6FCF7',
					bike: 'static/images/post/bike@2x.png',
					frame: 'static/images/post/Frame@2x.png',
					btnActive: '#187C18',
				},
				5: {
					cardBg: '#E3DDD1',
					progressMain: '#B48233',
					// 未完成进度条底色改为更明显的米色，避免与背景混淆
					progressEnd: '#E2D1B4',
					bike: 'static/images/post/bike@2x_3.png',
					frame: 'static/images/post/Frame@2x_3.png',
					btnActive: '#B48233',
				}
			};
			return map[key] || {
				cardBg: 'rgba(255, 255, 255, 0.95)',
				progressMain: '#03A9F4',
				progressEnd: '#e0e0e0',
				bike: 'static/images/post/bike@2x.png',
				frame: null,
				btnActive: '#37774C',
			};
		},

		getCardStyleByType(type) {
			const cfg = this.getThemeConfig(type);
			return { background: cfg.cardBg };
		},

		getProgressTrackStyle(item) {
			const cfg = this.getThemeConfig(item);
			// 进度条未完成部分底色
			return { backgroundColor: cfg.progressEnd };
		},

		getProgressFillStyle(item, schedule) {
			const cfg = this.getThemeConfig(item);
			const pct = Number(schedule);
			if (Number.isFinite(pct) && pct >= 100) {
				return { background: cfg.progressMain };
			}
			// 渐变：从“已完成主色”到“未完成底色”
			return { background: `linear-gradient(to right, ${cfg.progressMain} 0%, ${cfg.progressEnd} 100%)` };
		},

		getBikeIconSrc(item) {
			const cfg = this.getThemeConfig(item);
			return this.withStaticBase(cfg.bike);
		},

		getFrameIconSrc(item) {
			const cfg = this.getThemeConfig(item);
			return cfg.frame ? this.withStaticBase(cfg.frame) : '';
		},

		getActionBtnStyle(item, variant) {
			const cfg = this.getThemeConfig(item);
			if (variant === 'active') {
				return { background: cfg.btnActive, color: '#fff' };
			}
			return {};
		},

		// 标题与进度百分比使用主题主色
		getTitleStyle(item) {
			const cfg = this.getThemeConfig(item);
			return { color: cfg.progressMain };
		},

		// 左上角图标：type=3 使用 Frame@2x_3，其余使用 people@2x
		getHeaderIconSrc(item) {
			const type = this.getThemeKey(item);
			if (type === 1) {
				return this.withStaticBase('static/images/post/Frame_1.png');
			}
			if (type === 2) {
				return this.withStaticBase('static/images/post/Frame_2.png');
			}
			return this.withStaticBase('static/images/post/Frame_3.png');
		},

		// 进度百分比显示，最多两位小数，加 % 号
		formatSchedule(schedule) {
			const num = Number(schedule);
			if (!Number.isFinite(num)) return '0%';
			return `${num.toFixed(2).replace(/\\.00$/, '')}%`;
		},
		formatAward(award) {
			const val = parseFloat(award);
			return Number.isFinite(val) ? String(Math.round(val)) : '0';
		},
		rate(event, newRating) {
		      this.rating = newRating;
		    },
		getStr(n1,n2) {
			
			//this.schedule = this.reData['schedule'];
			//this.rating = this.reData['star'];
			//return this.reData['numberMembers']+"/"+this.reData['satisfy'];
			return n1+"/"+n2;
		},
		// 判断是否可领取奖励（职位1-4 一次性；职位5-7 需审核通过且每月固定日可领）
		canClaimReward(item) {
			if (!item) return false;
			const post = Number(item.post);
			const star = Number(item.star);
			const schedule = Number(item.schedule);
			if (star < 5 || schedule != 100 || item.btn === true) return false;

			// 职位 1-4：满足条件即可领取
			if (post >= 1 && post <= 4) return true;

			// 职位 5-7：需身份审核通过（一次即可），今日为每月领取日，且仅可领取当前最高达标档位
			if (post >= 5 && post <= 7) {
				if (!this.office || this.office.state != 1) return false;
				const highest = this.highestPost57Reached;
				if (!highest || Number(highest.post) !== post) return false; // 只能领最高达标档
				const approvalDay = Number(this.office.approval_day || this.office.approvalDay || 0);
				if (!approvalDay) return false;
				const today = new Date().getDate();
				return today === approvalDay;
			}
			return false;
		},

		getButtonText(item) {
			if (!item) return '';
			const post = Number(item.post);
			const schedule = Number(item.schedule);

			// 职位 5-7 且未达标：显示车辆数
			if (post >= 5 && post <= 7 && schedule < 100) {
				return `Pick up ${item.satisfy} vehicles`;
			}
			// 职位 5-7 已达标：身份审核一次即可，6-7档达标后无需再上传
			if (post >= 5 && post <= 7 && schedule >= 100) {
				if (!this.office || this.office.state != 1) {
					return this.$t('user.office[13]');
				}
				// 已审核通过，按最高达标档显示：仅最高档显示领取提示，下级档位显示已领/更高档
				const highest = this.highestPost57Reached;
				const approvalDay = Number(this.office.approval_day || this.office.approvalDay || 0);
				if (highest && Number(highest.post) === post && approvalDay) {
					return (this.$t('user.office[14]')).replace('{day}', approvalDay);
				}
				// 非最高档或暂无领取日，显示每月领取提示（兜底）
				if (approvalDay) {
					return (this.$t('user.office[14]')).replace('{day}', approvalDay);
				}
			}
			return `Pick up ${item.satisfy} vehicles`;
		},

		// 根据职位类型返回不同的小车图标
		getBikeImg(item) {
			try{
				const t = Number(item.type || item.types || 2);
				switch(t){
					case 1: return '/static/images/post/bike@2x_1.png';
					case 3: return '/static/images/post/bike@2x_3.png';
					case 2:
					default: return '/static/images/post/bike@2x.png';
				}
			}catch(e){
				return '/static/images/post/bike@2x.png';
			}
		},

		// 从本地缓存 InitData 读取 position.content；若无则调用后端接口获取并写入缓存
		loadInitData() {
			try{
				const s = localStorage.getItem('InitData');
				if(s){
					const init = JSON.parse(s);
					if(init && init.info && init.info.position && init.info.position.content){
						this.awardsContent = init.info.position.content || '';
						return;
					}
				}
			}catch(e){
				// ignore parse errors
			}
			// 回退：调用后端通用方法获取
			if(this.$Model && typeof this.$Model.GetBackData === 'function'){
				// GetBackData 的回调会直接返回 info 对象（见 src/common/Model.js）
				this.$Model.GetBackData((info) => {
					if(info){
						try{ localStorage.setItem('InitData', JSON.stringify(info)); }catch(e){}
						if(info.position && info.position.content){
							this.awardsContent = info.position.content || '';
						}
					}
				});
			}
		},
		openShow(item) {
			if (!item) return;
			if (!this.canClaimReward(item)) {
				return this.$Dialog.Toast(this.$t("user.office[8]"));
			}

			const post = Number(item.post);
			const applyParams = post >= 5 && post <= 7 ? { post } : {};
			this.$Model.Apply(applyParams, data => {
				if (data.code == 1) {
					// 领取成功，显示自定义弹窗：Табрик мегӯям ки ба (name) расидед ва (awardTJS) мукофот гирифтед
					const name = item.name || '';
					const awardVal = parseFloat(item.award);
					const awardStr = Number.isFinite(awardVal) ? Math.round(awardVal) + 'TJS' : '0TJS';
					this.rewardPopupMessage = `Табрик мегӯям, ки ба (${name}) расидед ва (${awardStr}) мукофот гирифтед`;
					this.rewardPopupBgUrl = this.withStaticBase('static/images/vip/tz_bg1.png');
					this.showRewardSuccessPopup = true;
				} else {
					this.$Dialog.Toast(data.msg || data.code_dec || '');
				}
			});
		},

		closeRewardPopup() {
			this.showRewardSuccessPopup = false;
			window.location.reload();
		},
		afterRead(file) {
		this.uploadImgs(file);
		},
		uploadImgs(file){
			if (!file.file.type.match(/image/)){
				file.status = 'failed'
				file.message = 'failed'
				return;
			}
			this.$Util.CompressImg(file.file.type,file.content,750,(image)=>{
				let param = new FormData();
				param.append('token',localStorage['Token']);
				param.append('type',3);
				param.append('image',image,file.file.name);
				this.$Model.UploadImg(param,(data)=>{
				if(data.code==1){
					file.message = 'success'
					file.status = 'success'
					file.url = data.url
				}else{
					file.status = 'failed'
					file.message = 'failed'
				}
				});
			})
		},
		submitPostDebounce:lodash.debounce(function (){this.submitPost()},500),
		submitPost(){
			if(this.img_1.length>0){
				this.formData.img_1 = this.img_1[0].url
			}else{
				this.$Dialog.Alert(this.$t('positions.job[6]'));
				return;
			}
			if(this.img_3.length>0){
				this.formData.img_3 = this.img_3[0].url
			}else{
				this.$Dialog.Alert(this.$t('positions.job[23]'));
				return;
			}
			if(this.img_2.length>0){
				this.formData.img_2 = this.img_2[0].url
			}else{
				this.$Dialog.Alert(this.$t('positions.job[7]'));
				return;
			}
			// 职位 5-7 档提交审核时带上档位 post
			const target = this.uploadTargetItem;
			this.formData.postid = target ? String(target.post) : '';
			this.$Model.addPostAudit(this.formData,(res)=>{
				this.$Dialog.Toast(res.msg);
				if(res.code==1){
					window.location.reload();
				}
			})
		},
		// 跳转到职位描述页面
		goPositionIntro(){
			this.$router.push('/user/postionIntro')
		}
	}
}
	
</script>

<style scoped>
	.IndexBox {
		background: linear-gradient(to bottom, 
			#9DDEE6 0%,
			#B8E6ED 25%,
			#D1EEF3 50%,
			#E8F6F9 75%,
			#FFFFFF 100%);
		height: 100%;
		width: 100%;
		min-height: 100vh;
	}
	
	.content-wrapper {
		padding-top: 60%;
		text-align: center;
		padding-bottom: 2rem;
		position: relative;
	}
	
	.content-wrapper::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 60%;
		/* 背景图通过 CSS 变量传入，支持根路径 / 与 /sgm 等二级目录 */
		background: var(--bg-url) no-repeat center top;
		background-size: 100% auto;
		z-index: 0;
		pointer-events: none;
	}
	
	.position-title {
		font-size: 18px;
		font-weight: bold;
		color: #000;
		margin-bottom: 1rem;
		text-align: center;
		position: relative;
		z-index: 1;
	}
	
	.reward-card {
		/* 背景色按 post/type 分块，通过行内 style 覆盖 */
		border-radius: 25px;
		margin: 10px;
		padding: 1rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		position: relative;
		z-index: 1;
	}

	/* 分块内层：保持卡片主体白底，外层用主题背景做“分块” */
	.reward-card__inner {
		/* 稍微降低白底不透明度，使背景主题色透出一点 */
		background: rgba(255, 255, 255, 0.78);
		border-radius: 20px;
		padding: 0.75rem 0.75rem 1rem;
		margin-top: 8px;
	}
	
	.reward-item {
		padding: 0.5rem 0;
	}
	
	.reward-header {
		display: flex;
		align-items: center;
		padding: 0.5rem 0;
		margin-bottom: 1rem;
		margin-left: 0.6rem;
	}
	
	.reward-icon {
		width: 24px;
		height: 24px;
		margin-right: 8px;
	}
	
	.reward-text {
		font-size: 14px;
		color: #000;
		font-weight: 500;
	}
	
	.reward-award {
		margin-left: auto;
		font-size: 14px;
		font-weight: 500;
		white-space: nowrap;
	}
	
	.progress-container {
		margin-top: 1rem;
	}
	
	.progress-bar-wrapper {
		position: relative;
		margin-bottom: 1rem;
	}

	/* 进度条 + 百分比一行展示 */
	.progress-bar-row {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 0 16px;
		box-sizing: border-box;
	}
	
	.progress-info-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.5rem;
	}
	
	.progress-bar-bg {
		position: relative;
		flex: 1;
		height: 10px;
		background-color: #e0e0e0;
		border-radius: 5px;
		/* 允许小车图标超出进度条边界显示在上方 */
		overflow: visible;
	}

	/* 小车图标定位到进度条上方，并以 left 百分比为定位点，水平居中 */
	.bike-icon {
		position: absolute;
		top: -18px; /* 调整使图标位于条上方 */
		transform: translateX(-50%);
		width: 22px;
		height: 22px;
		z-index: 3;
		pointer-events: none;
	}
	
	.progress-bar-fill {
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		background-color: #03A9F4;
		border-radius: 5px;
		transition: width 0.3s ease;
	}
	
	/* 进度百分比显示在进度条末尾（条外侧） */
	.progress-percent-out {
		font-size: 12px;
		font-weight: 500;
		white-space: nowrap;
	}
	
	.progress-text {
		display: flex;
		align-items: center;
		margin-left: 16px;
		justify-content: flex-start;
		font-size: 12px;
		color: #666;
	}
	
	.progress-separator {
		margin: 0 4px;
	}
	
	.progress-percent {
		font-size: 12px;
		color: #000;
		font-weight: 500;
	}
	
	.action-btn {
		width: 90%;
		margin: 1rem auto 0;
		padding: 12px;
		text-align: center;
		border-radius: 8px;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.3s ease;
		user-select: none;
	}
	
	.action-btn.active {
		background: #37774C;
		color: #fff;
	}
	
	.action-btn.disabled {
		background: #ccc;
		color: #fff;
		cursor: not-allowed;
	}
	
	.action-btn.goto-btn {
		background: #37774C;
		color: #fff;
		cursor: pointer;
	}
	
	.action-btn.active:hover,
	.action-btn.goto-btn:hover {
		opacity: 0.9;
	}
	.upload-section {
		padding: 1rem;
	}
	
	.upload-header {
		text-align: left;
		margin-bottom: 1rem;
	}
	
	.upload-title {
		font-size: 14px;
		font-weight: 800;
		margin-bottom: 0.5rem;
		color: #000;
	}
	
	.upload-comments {
		color: #000;
		font-size: 12px;
		line-height: 1.6;
	}
	
	.comments-label {
		color: red;
		margin-bottom: 0.5rem;
	}
	
	.upload-images {
		display: flex;
		justify-content: space-around;
		margin: 1rem 0;
		gap: 1rem;
	}
	
	.upload-item {
		flex: 1;
	}
	
	.uploaded-img {
		width: 100px;
		height: 100px;
		border-radius: 8px;
		object-fit: cover;
	}
	
	.submit-btn {
		font-size: 16px;
		background: linear-gradient(to right, #37774C, #37774C);
		border: none;
		margin-top: 1rem;
	}
	
	.awards-section {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 25px;
		margin: 10px;
		padding: 1rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		position: relative;
		z-index: 1;
	}
	
	.awards-header {
		display: flex;
		align-items: center;
		padding: 0.5rem 0;
		margin-bottom: 1rem;
	}
	
	.awards-icon {
		width: 24px;
		height: 24px;
		margin-right: 8px;
	}
	
	.awards-text {
		font-size: 14px;
		color: #000;
		font-weight: 500;
	}
	
	.awards-content {
		text-align: left;
		font-size: 12px;
		color: #666;
		line-height: 1.6;
		padding: 0.5rem 0;
	}
	
	.van-progress__pivot {
		font-size: 14px;
	}
	
	span {
		text-wrap-mode: wrap;
	}

  .nav-right-btn {
    font-size: 13px;
    color: #ffffff;
    padding: 4px 10px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
  }

  /* 领取奖励成功弹窗 */
  .reward-success-popup {
    width: 270px;
    height: 450px;
    background-size: 270px 450px;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 5px;
    padding-top: 230px;
  }

  .reward-success-content {
    margin: 0 25px;
    padding: 20px 15px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 15px;
    border: 1px solid #EAEAEA;
    min-height: 115px;
  }

  .reward-success-text {
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    text-align: center;
    white-space: pre-line;
  }

  .reward-success-btn {
    font-size: 18px;
    background-color: #37774C;
    width: 80%;
    color: #fff;
    border: none;
  }

  .reward-close {
    display: block;
    margin-top: 12px;
    text-align: center;
  }
</style>